// src/App.js - CORRECTED VERSION WITH PROPER FILE NAMES
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import ProtectedRoute from './components/ProtectedRoute';
import ManagementLookupPage from './pages/ManagementLookupPage';

// Pages
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import NotFoundPage from './pages/NotFoundPage';
import ServerErrorPage from './pages/ServerErrorPage';

// Admin Pages - CORRECTED NAMES ✅
import UserListPage from './pages/UserListPage';
import ExerciseListPage from './pages/ExerciseListPage';
import CommandListPage from './pages/CommandListPage';
import PersonnelListPage from './pages/PersonnelListPage';

// Verification
import VerificationPage from './pages/VerificationPage';
import FlaggedRecapturesPage from './pages/FlaggedRecapturesPage';

// Reports
import ReportsPage from './pages/ReportsPage';
import PersonnelVerificationStatusReport from './pages/reports/PersonnelVerificationStatusReport';
import DailyProgressReport from './pages/reports/DailyProgressReport';
import SalaryComplaintsReport from './pages/reports/SalaryComplaintsReport';
import OfficerPerformanceReport from './pages/reports/OfficerPerformanceReport';
import TransferRequestsReport from './pages/reports/TransferRequestsReport';

// Create theme - NIS GREEN THEME (exact logo color)
const theme = createTheme({
  palette: {
    primary: {
      main: '#00a651',      // Exact NIS Logo Green
      light: '#33b86f',     // Lighter green
      dark: '#008241',      // Darker green
    },
    secondary: {
      main: '#f9a825',      // Gold/Yellow accent
      light: '#ffd54f',
      dark: '#c17900',
    },
    success: {
      main: '#2e7d32',
      light: '#4caf50',
      dark: '#1b5e20',
    },
    warning: {
      main: '#ed6c02',
      light: '#ff9800',
      dark: '#e65100',
    },
    error: {
      main: '#d32f2f',
      light: '#ef5350',
      dark: '#c62828',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 600 },
    h2: { fontWeight: 600 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <ToastProvider>
          <Router>
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/error" element={<ServerErrorPage />} />

              {/* Protected Routes */}
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    
                      <DashboardPage />
                    
                  </ProtectedRoute>
                }
              />
              
              {/* Admin Routes - CORRECTED ✅ */}
              <Route
                path="/users"
                element={
                  <ProtectedRoute requiredRole="ADMIN">
                    
                      <UserListPage />
                    
                  </ProtectedRoute>
                }
              />
              <Route
                path="/exercises"
                element={
                  <ProtectedRoute requiredRole="ADMIN">
                    
                      <ExerciseListPage />
                    
                  </ProtectedRoute>
                }
              />
              <Route
                path="/commands"
                element={
                  <ProtectedRoute requiredRole="ADMIN">
                    
                      <CommandListPage />
                    
                  </ProtectedRoute>
                }
              />
              <Route
                path="/personnel"
                element={
                  <ProtectedRoute requiredRole="ADMIN">
                    
                      <PersonnelListPage />
                    
                  </ProtectedRoute>
                }
              />
              <Route
                path="/lookup"
                element={
                  <ProtectedRoute>
                      <ManagementLookupPage />
                  </ProtectedRoute>
                }
              />
              {/* Verification Routes */}
              <Route
                path="/verification"
                element={
                  <ProtectedRoute>
                    
                      <VerificationPage />
                    
                  </ProtectedRoute>
                }
              />

              <Route
                path="/flagged-recaptures"
                element={
                  <ProtectedRoute requiredRole="ADMIN">
                      <FlaggedRecapturesPage />
                  </ProtectedRoute>
                }
              />

              {/* Reports Routes */}
              <Route
                path="/reports"
                element={
                  <ProtectedRoute>
                    
                      <ReportsPage />
                    
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reports/personnel-verification-status"
                element={
                  <ProtectedRoute>
                    
                      <PersonnelVerificationStatusReport />
                    
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reports/daily-progress"
                element={
                  <ProtectedRoute>
                    
                      <DailyProgressReport />
                    
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reports/salary-complaints"
                element={
                  <ProtectedRoute>
                    
                      <SalaryComplaintsReport />
                    
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reports/officer-performance"
                element={
                  <ProtectedRoute>
                    
                      <OfficerPerformanceReport />
                    
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reports/transfer-requests"
                element={
                  <ProtectedRoute>
                    
                      <TransferRequestsReport />
                    
                  </ProtectedRoute>
                }
              />

              {/* 404 - Must be last */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Router>
        </ToastProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;